import * as React from 'react';

function SvgIconExport(props) {
  return (
    <svg width={87} height={92} xmlns="http://www.w3.org/2000/svg" {...props}>
      <g fill="none" fillRule="evenodd">
        <path
          d="M53.5 88.5H4a.5.5 0 01-.5-.5V4c0-.28.22-.5.5-.5h74c.28 0 .5.22.5.5v57a1.5 1.5 0 003 0V4A3.5 3.5 0 0078 .5H4A3.5 3.5 0 00.5 4v84A3.5 3.5 0 004 91.5h49.5a1.5 1.5 0 000-3z"
          fill="#C8C9CB"
          fillRule="nonzero"
        />
        <path fill="#C8C9CB" fillRule="nonzero" d="M17 43h48v-3H17z" />
        <path stroke="#C8C9CB" strokeWidth={3} d="M18.5 19.5h11v11h-11z" />
        <path
          fill="#C8C9CB"
          fillRule="nonzero"
          d="M39 32h26v-3H39zm0-11h26v-3H39zM17 54h48v-3H17zm35 26h32v-3H52z"
        />
        <path
          d="M84.49 77.1a2 2 0 000 2.83l-1.42-1.42 1.42-1.41zM76 71.44V67.2l10.6 10.6a1 1 0 010 1.42L76 89.82v-4.24l7.07-7.07L76 71.44zm8.49 5.66a2 2 0 000 2.83l-1.42-1.42 1.42-1.41zM76 71.44V67.2l10.6 10.6a1 1 0 010 1.42L76 89.82v-4.24l7.07-7.07L76 71.44z"
          fill="#C8C9CB"
          fillRule="nonzero"
        />
      </g>
    </svg>
  );
}

export default SvgIconExport;
